module.exports = __webpack_public_path__ + "img/TaskFino-Login-page.05199187.jpg";